import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "../../../utils/fetchBaseFPNetQuery";
import {addBaseQueryParams, addURI, BaseQueryParams, transformResponse} from "@commons/utils/APIParams";
import {ElementiRMLXTabella, getTagsList} from "@commons/mapping/DataTablesSchema";
import {ElementoRMLXTabellaRecord} from "@commons/mapping/ElementoRMLXTabellaRecord";
import {config} from "@commons/config.instance";

export interface GetTabellaParams extends BaseQueryParams {
    idAzienda: number;
    codice: string; // id della tabella
}

export const elementoRMLXTabellaApi = createApi({
    reducerPath: 'elementoRMLXTabellaApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    tagTypes: ['elementoRMLXTabella'],
    endpoints: (builder) => ({
        getElementiRMLXTabella: builder.query<ElementiRMLXTabella, Partial<GetTabellaParams>>({
            query: (filter) => {
                let params: string[] = addBaseQueryParams(filter);
                const queryParams = `${params.length > 0 ? '?' + encodeURI(params.join("&")) : ''}`;
                return `/azienda/${filter.idAzienda}/tabella/elementi-RML/${filter.codice}/elemento` + queryParams;
            },
            transformResponse,
            providesTags: (result) => getTagsList<ElementoRMLXTabellaRecord>(result, 'elementoRMLXTabella'),
        }),
        getElemento: builder.query<ElementoRMLXTabellaRecord, string | undefined>({
            query: (URI) => {
                return URI ? URI : `/${URI}`;
            },
            transformResponse: addURI
            //providesTags: (result, error, URI) => [{type: 'elementoRMLXTabella', URI}],
        }),
        deleteElemento: builder.mutation<void, string>({
            query: (URI) => ({
                url: URI ? URI : '',
                method: 'DELETE'
            }),
            invalidatesTags: [{type: 'elementoRMLXTabella', id: 'LIST'}],
        }),
        updateElemento: builder.mutation<Partial<ElementoRMLXTabellaRecord>, Partial<ElementoRMLXTabellaRecord> & Pick<ElementoRMLXTabellaRecord, 'URI'>>({
            query: ({URI, ...patch}) => ({
                url: URI ? URI : '',
                method: 'PUT',
                body: patch,
            }),
            transformResponse,
            invalidatesTags: (result, error, {URI}) => [{type: 'elementoRMLXTabella', URI}],
        }),
        moveElemento: builder.mutation<void, string>({
            query: (URI) => ({
                url: URI ? URI : '',
                method: 'PATCH'
            }),
            invalidatesTags: [{type: 'elementoRMLXTabella', id: 'LIST'}],
        }),
        insertElemento: builder.mutation<Partial<ElementoRMLXTabellaRecord>, Partial<ElementoRMLXTabellaRecord>>({
            query: (payload) => ({
                url: `/azienda/${payload.idAzienda}/tabella/elementi-RML/${payload.codice}/elemento`,
                method: 'POST',
                body: payload,
            }),
            transformResponse,
            invalidatesTags: [{type: 'elementoRMLXTabella', id: 'LIST'}],
        }),

    }),
})
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetElementiRMLXTabellaQuery,
    useLazyGetElementoQuery,
    useUpdateElementoMutation,
    useMoveElementoMutation,
    useInsertElementoMutation,
    useDeleteElementoMutation,
} = elementoRMLXTabellaApi;